<template>
  <el-row>
    <el-row class="pb-3">
      <el-col>
        <el-card shadow="never">
          <OpportunitySteps :opportunity="event.account.lead" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :span="9">
        <el-card
          v-loading="loadingOpportunity"
          header="Key Fields"
          shadow="never"
        >
          <OpportunityPeekKeyFields :opportunity="event.account.lead" />
        </el-card>
      </el-col>

      <el-col :span="15">
        <el-row class="pb-3">
          <el-col>
            <el-card shadow="never">
              <template #header>
                Events Notes
                <el-button
                  type="text"
                  @click.native="$refs['eventNotes'].create()"
                >
                  New Note
                </el-button>
              </template>
              <Notes
                ref="eventNotes"
                :resource="event"
                truncate
                paginate
                pagination-layout="prev, pager, next"
                :limit="3"
              />
            </el-card>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-card
              shadow="never"
            >
              <template #header>
                Opportunity Notes
                <el-button
                  type="text"
                  @click.native="$refs['opportunityNotes'].create()"
                >
                  New Note
                </el-button>
              </template>
              <Notes
                ref="opportunityNotes"
                :resource="event.account"
                truncate
                paginate
                pagination-layout="prev, pager, next"
                :limit="3"
              />
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import OpportunitySteps from '@/components/Application/Sales/Opportunities/Opportunity/Steps'
import OpportunityPeekKeyFields from '@/components/Application/Sales/Opportunities/Opportunity/Peek/KeyFields'
import Notes from '@/components/Notes'
import AccountEvent from '@/plugins/sdk/resources/Account/Event'
import Account from '@/plugins/sdk/resources/Account'
import AccountLead from '@/plugins/sdk/resources/Account/Lead'

export default {
  components: {
    OpportunitySteps,
    OpportunityPeekKeyFields,
    Notes
  },
  props: {
    event: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof AccountEvent &&
          value.account instanceof Account &&
          value.account.lead instanceof AccountLead
      }
    }
  },
  data () {
    return {
      loadingOpportunity: true
    }
  },
  created () {
    this
      .event
      .account
      .lead
      .refresh(builder => {
        builder.include = [
          'account.portfolio',
          'suggested_carriers.carrier',
          'incumbent_carriers.carrier',
          'freights.type'
        ]
      })
      .finally(() => { this.loadingOpportunity = false })
  }
}
</script>
